import { CrudModel } from "../plugins/Cruxtify/CrudModel";
import {
  BooleanField,
  DateTimeField,
  NumberField,
  RelationshipField,
  SelectField,
  StringField,
} from "../plugins/Cruxtify/field-types";
import {
  BooleanProperty,
  DateTimeProperty,
  NumberProperty,
  RelationshipProperty,
  StringProperty,
} from "../plugins/Cruxtify/property-types";
import {
  UserPermission,
  UserPermissions,
  UserRole,
} from "../plugins/Cruxtify/UserPermission";
import { extendWithDeleted } from "./collection-layouts/extend-with-deleted";

export class Crew extends CrudModel {
  protected static _typeLabel = "Crew";
  protected static asProperty = "crew";
  public static api = {
    path: "crews",
  };
  protected static routeBase = "crews";
  protected userIdField = [];
  protected static userPermissions = new UserPermissions(
    {
      [UserRole.SuperAdmin]: UserPermission.Edit,
      [UserRole.EntityOwner]: UserPermission.Edit,
      [UserRole.LoggedIn]: UserPermission.Edit,
    },
    UserPermission.Read
  );

  protected static propertyDefinitions = [
    {
      type: NumberProperty,
      opts: {
        name: "id",
        label: "ID",
        userPermissions: UserPermission.Hidden,
      },
    },
    {
      type: DateTimeProperty,
      opts: {
        name: "deleted_at",
        label: "Deleted At",
        userPermissions: UserPermission.Read,
      },
    },
    {
      type: DateTimeProperty,
      opts: {
        name: "created_at",
        label: "Created At",
        userPermissions: UserPermission.Read,
        computed: true,
      },
    },
    {
      type: DateTimeProperty,
      opts: {
        name: "updated_at",
        label: "Updated At",
        userPermissions: UserPermission.Read,
        computed: true,
      },
    },
    {
      type: StringProperty,
      opts: {
        name: "name",
        label: "Name",
        rules: ["required"],
      },
    },
    {
      type: StringProperty,
      opts: {
        name: "type",
        label: "Type",
        rules: ["required"],
      },
    },
    {
      type: NumberProperty,
      opts: {
        name: "crew_size",
        label: "Crew Size",
      },
    },
    {
      type: BooleanProperty,
      opts: {
        name: "is_active",
        label: "Active",
        default: true,
      },
    },
    {
      type: NumberProperty,
      opts: {
        name: "display_order",
        label: "Display Order",
      },
    },
    {
      type: RelationshipProperty,
      opts: {
        name: "last_mod_author",
        label: "Last Updated By",
        relatedModel: "User",
        userPermissions: UserPermission.Read,
        computed: true,
      },
    },
    {
      type: RelationshipProperty,
      opts: {
        name: "author",
        label: "Author",
        relatedModel: "User",
        userPermissions: UserPermission.Read,
        computed: true,
      },
    },
  ];

  protected static fieldDefinitions = [
    { type: NumberField, opts: { property: "id" } },
    { type: DateTimeField, opts: { property: "created_at" } },
    { type: DateTimeField, opts: { property: "updated_at" } },
    { type: DateTimeField, opts: { property: "deleted_at" } },
    { type: StringField, opts: { property: "name", md: 6, isPrimaryLabelField: true } },
    {
      type: SelectField,
      opts: {
        property: "type",
        // Must match crew_type in paperallergy2/config/job_board.php.
        options: ["roof", "gutter", "siding", "repair"],
        md: 6,
      },
    },
    { type: NumberField, opts: { property: "crew_size", md: 6 } },
    { type: NumberField, opts: { property: "display_order", md: 6 } },
    { type: BooleanField, opts: { property: "is_active" } },
    { type: RelationshipField, opts: { property: "last_mod_author" } },
    { type: RelationshipField, opts: { property: "author" } },
  ];

  protected static collectionLayoutDefinitions = extendWithDeleted([
    {
      id: "table",
      columnFields: ["name", "type", "crew_size", "is_active"],
      filterFields: ["type", "is_active"],
      useModal: true,
      defaultSort: [
        {
          field: "name",
          order: "asc",
        },
      ],
    },
    {
      id: "asRelationship",
      columnFields: ["name", "type"],
    },
  ]);

  protected static modelLayoutDefinitions = [
    {
      id: "Crudform",
      fieldSets: [
        {
          id: "0",
          fields: ["name", "type", "crew_size", "display_order", "is_active"],
        },
        {
          id: "1",
          fields: ["author", "last_mod_author"],
        },
      ],
    },
  ];
}
